export const NAME = 'applicationEngine'

// Waiter call names
export const GET_ALL_APPLICATIONS = 'GET_All_APPLICATIONS'
export const GET_APPLICATION = 'GET_APPLICATION'
export const PUT_APPLICATION = 'PUT_APPLICATION'
export const POST_APPLICATION_SUBMISSION_EVENT =
  'POST_APPLICATION_SUBMISSION_EVENT'

export const LOAD_APPLICATIONS = 'LOAD_APPLICATIONS'
export const LOAD_LIST = 'LOAD_LIST'

// search related action types
export const CHANGE_SORT = 'CHANGE_SORT'
export const RESET_FILTERS = 'RESET_FILTERS'
export const SET_COMPANY_ID = 'SET_COMPANY_ID'
export const TOGGLE_FILTERS = 'TOGGLE_FILTERS'
export const UPDATE_BENEFIT_EFFECTIVE_DATE = 'UPDATE_BENEFIT_EFFECTIVE_DATE'
export const UPDATE_CART_OPEN = 'UPDATE_CART_OPEN'
export const UPDATE_FILTER = 'UPDATE_FILTER'
export const UPDATE_KEYWORD = 'UPDATE_KEYWORD'
export const UPDATE_NEEDS_ATTENTION = 'UPDATE_NEEDS_ATTENTION'
export const UPDATE_NEEDS_CANCELLATION = 'UPDATE_NEEDS_CANCELLATION'
export const UPDATE_SAME_CARRIER = 'UPDATE_SAME_CARRIER'
export const UPDATE_TEST_USER = 'UPDATE_TEST_USER'
export const UPDATE_COMMISSION_FILTER = 'UPDATE_COMMISSION_FILTER'
export const UPDATE_ASSIGNEE_FILTER = 'UPDATE_ASSIGNEE_FILTER'
export const UPDATE_SHOW_UNASSIGNED = 'UPDATE_SHOW_UNASSIGNED'
export const LOAD_SAVED_FILTERS = 'LOAD_SAVED_FILTERS'
export const UPDATE_APPLICATION = 'UPDATE_APPLICATION'
export const UPDATE_APPLICATION_ASSIGNEE = 'UPDATE_APPLICATION_ASSIGNEE'
export const VIEW_MORE = 'VIEW_MORE'
export const VIEW_ALL = 'VIEW_ALL'
export const RESET_COMPONENT = 'RESET_COMPONENT'
export const UPDATE_CARRIER_PLAN_CHANGE = 'UPDATE_CARRIER_PLAN_CHANGE'

export const CREATE_NOTIFICATION = 'CREATE_NOTIFICATION'

export const DEFAULT_BENEFIT_EFFECTIVE_DATE = '01-01-2024'
export const SET_BENEFIT_EFFECTIVE_DATE_FOR_QUERY =
  'SET_BENEFIT_EFFECTIVE_DATE_FOR_QUERY'
export const SET_BENEFIT_EFFECTIVE_DATE_RANGE_FOR_QUERY =
  'SET_BENEFIT_EFFECTIVE_DATE_RANGE_FOR_QUERY'
export const STORAGE_FILTER = 'app-eng-filters'
export const STORAGE_VERIFIED = 'ae_verified'
export const SET_SELECTED_APPLICATIONS = 'SET_SELECTED_APPLICATIONS'

export default [
  CHANGE_SORT,
  CREATE_NOTIFICATION,
  LOAD_APPLICATIONS,
  LOAD_LIST,
  RESET_FILTERS,
  RESET_COMPONENT,
  SET_COMPANY_ID,
  TOGGLE_FILTERS,
  UPDATE_BENEFIT_EFFECTIVE_DATE,
  UPDATE_CART_OPEN,
  UPDATE_FILTER,
  UPDATE_KEYWORD,
  UPDATE_NEEDS_ATTENTION,
  UPDATE_NEEDS_CANCELLATION,
  UPDATE_SAME_CARRIER,
  UPDATE_TEST_USER,
  UPDATE_COMMISSION_FILTER,
  UPDATE_ASSIGNEE_FILTER,
  UPDATE_SHOW_UNASSIGNED,
  LOAD_SAVED_FILTERS,
  UPDATE_APPLICATION,
  UPDATE_APPLICATION_ASSIGNEE,
  VIEW_MORE,
  VIEW_ALL,
  SET_BENEFIT_EFFECTIVE_DATE_FOR_QUERY,
  SET_BENEFIT_EFFECTIVE_DATE_RANGE_FOR_QUERY,
  SET_SELECTED_APPLICATIONS,
  UPDATE_CARRIER_PLAN_CHANGE,
]
